import React, { useState } from 'react';

import { Grid } from '@material-ui/core';
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import { TeamType } from 'typings/markets/api';
import Spacer from '@/components/ui-components/Spacer';
import PersonCard from './PersonCard';
import Typography from '../../components/Typography';

interface Props {
  team: TeamType[];
}

const defaultProps = {};

const Team = ({ team }: Props) => {
  const { t } = useTranslation('markets');
  const [activeTeamMember, setActiveTeamMember] = useState< TeamType | null>(
    null,
  );
  return (
    <>
      <Typography variant="header">
        {t('markets.detailView.team.title')}
      </Typography>
      <Spacer spacing={2} />

      {/* animation */}
      <AnimateSharedLayout type="crossfade">
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
        >
          {!activeTeamMember
            && team.map((teamMember, index) => (
              <Grid item xs={12} sm={4} md={3} key={teamMember.name}>
                <motion.div
                  layoutId={index !== 0 ? teamMember.name : undefined}
                  // initial={{ opacity: 0 }}
                  // animate={{ opacity: 1 }}
                  // exit={{ opacity: 0 }}
                >
                  <PersonCard
                    name={teamMember.name}
                    linkedin={teamMember.linkedin_url}
                    title={teamMember.position}
                    background={teamMember.bio}
                    photo={teamMember.image}
                    onBackgroundOpen={() => setActiveTeamMember(teamMember)}
                    isActive={false}
                  />
                </motion.div>
              </Grid>
            ))}
        </Grid>
        {activeTeamMember && (
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
          >
            <Grid item xs={12} sm={4}>
              <motion.div layoutId={activeTeamMember.name}>
                <PersonCard
                  name={activeTeamMember.name}
                  linkedin={activeTeamMember.linkedin_url}
                  title={activeTeamMember.position}
                  background={activeTeamMember.bio}
                  photo={activeTeamMember.image}
                  onBackgroundOpen={() => setActiveTeamMember(null)}
                  isActive
                />
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={8}>
              {/* <AnimatePresence> */}
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <Typography variant="base">{activeTeamMember.bio}</Typography>
              </motion.div>
              {/* </AnimatePresence> */}
            </Grid>
          </Grid>
        )}
      </AnimateSharedLayout>

      {/* statics */}
      {/* <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        {team.map((teamMember) => (
          <Grid item xs={12} sm={4} md={3} key={teamMember.name}>
            <motion.div layoutId={teamMember.name}>
              <PersonCard
                name={teamMember.name}
                linkedin={teamMember.linkedin}
                title={teamMember.title}
                background={teamMember.background}
                photo={teamMember.photo}
                onBackgroundOpen={() => setActiveTeamMember(teamMember)}
              />
            </motion.div>
          </Grid>
        ))}
      </Grid> */}
    </>
  );
};

Team.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default Team;
